import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { get } from 'lodash';
import { ModalComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';
import { Subject } from 'rxjs';
import {BidListService, BuyErrors, DateUtilsService} from 'remarketing-angular-library';
import {AutoBidWithdrawModalItemModel} from '../../models/auto-bid-withdraw-modal-item.model';
import {takeUntil} from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { CurrencyFormatService } from 'smartauction-frontend-micro-library';
import {
  ActionSubmittingComponent
} from '../../../shared/ui/comment/modal-actions/action-submitting/action-submitting.component';
import {
  ActionSubmittedComponent
} from '../../../shared/ui/comment/modal-actions/action-submitted/action-submitted.component';
import { TranslocoDirective } from '@jsverse/transloco';


@Component({
    selector: 'app-auto-bid-withdraw-modal',
    templateUrl: './auto-bid-withdraw-modal.component.html',
    styleUrls: ['./auto-bid-withdraw-modal.component.scss'],
    imports: [TrapFocusComponent, ActionSubmittingComponent, ActionSubmittedComponent, ModalComponent, TranslocoDirective]
})
export class AutoBidWithdrawModalComponent {
  @Input() tenantName: string;
  @Input() modalId = 'Auto-Bid-Withdraw-Modal';
  @Input() item: AutoBidWithdrawModalItemModel;
  @Output() withdrawSent = new EventEmitter();
  @Output() closed = new EventEmitter();
  @ViewChild(ModalComponent)
  modal: ModalComponent;
  errorMessage: string;

  private destroyed$ = new Subject();

  withdrawState: 'withdrawing' | 'withdrawComplete' | 'withDrawModalOpened' = 'withDrawModalOpened';

  get bidItemAmount() {
    return this.currencyFormatService.formatCurrency(get(this.item, 'amount', 0), false).replaceAll('-', '');
  }

  get getAutoBidAmount() {
    return this.currencyFormatService.formatCurrency(get(this.item, 'autoBidAmount', 0), false).replaceAll('-', '');
  }

  constructor(
    private bidListService: BidListService,
    private readonly currencyFormatService: CurrencyFormatService,
    private readonly dateUtilsService: DateUtilsService
  ) {}

  confirm() {
    this.withdrawState = 'withdrawing';
    const {
      auctionItemUuid,
      buyerOeUuid,
      financeSourceUuid,
      financeSourceAch,
      localDelivery,
      amount,
      autobidUuid
    } = this.item;
    const payload = {
      auctionItemUuid,
      buyerOeUuid,
      financeSourceAch,
      financeSourceUuid,
      localDelivery,
      autobidUuid,
      amount,
      bidStatus: 'WITHDRAWN'
    };

    this.bidListService
      .autoBidUpdate(payload)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        response => {
          this.withdrawState = 'withdrawComplete';
          this.withdrawSent.emit();
        },
        error => {
          this.errorMessage = this.getBidError(error);
          this.withdrawState = 'withDrawModalOpened';
        }
      );
  }

  show() {
    this.withdrawState = 'withDrawModalOpened';
    this.errorMessage = null;
    this.modal.show();

    setTimeout(() => {
      this.focusHeader();
    }, 2000);
  }

  focusHeader() {
    const modalHeader = document.getElementById('Auto-Bid-Withdraw-Modal');

    if (modalHeader) {
      modalHeader.focus();
    }
  }

  close() {
    this.modal.close();
    this.closed.emit();
  }

  private getBidError(errorResponse: HttpErrorResponse): string {
    /* istanbul ignore next */
    if (errorResponse.error instanceof ErrorEvent) {
      return BuyErrors.MSG_BUY_002;
    }
    const error = get(errorResponse, 'error.errors[0]', { code: 'No Error Found' });
    return BuyErrors.fromBuyErrors(error.code);
  }

  localizeDateAndTime(dateTime) {
    return `${this.dateUtilsService.localizeDateAndTime(dateTime)} ET`;
  }
}
